/**
 * Standalone entry — order.app2food.com/olo/{storeId}.
 *
 * This product stays. The embed is additive: with no embed config present the
 * config module resolves to standalone defaults that reproduce the original
 * behaviour exactly (path routing, /olo/{storeId} basename, unprefixed storage
 * keys), so nothing here changes for existing customers.
 */

// Must stay the first import: captures location.hash before storeSlice's
// legacy UTM fallback can strip it. See src/embed/deepLink.ts.
import "./embed/deepLink";

import ReactDOM from "react-dom/client";
import { AppRoot, initSentry } from "./Root";

initSentry();

ReactDOM.createRoot(document.getElementById("root")!).render(<AppRoot />);
